<div class="mm-page mm-slideout" tabindex="-1" id="mm-6">
  <div class="dialog-off-canvas-main-canvas" data-off-canvas-main-canvas="">

    <div class="off-canvas-wrapper">
      <div class="inner-wrap off-canvas-wrapper-inner" id="inner-wrap" data-off-canvas-wrapper="">
        <router-outlet></router-outlet>
        <app-footer></app-footer>
      </div>
    </div>
  </div>

</div>